import Vue from "vue";
import VueLocalStorage from "vue-localstorage";
import Qs from "qs";

import * as apiAdmin from "@/apis/admin";

import App from "@/components/App.vue";
import router from "@/router/index";
import store from "@/store";

import ElementUI from 'element-ui';
import "@/styles/index.scss";

import { ValidationProvider, ValidationObserver, localize, extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";

for (let rule in rules) {
  extend(rule, rules[rule]);
}

Vue.use(VueLocalStorage);
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });

localize({ zh_CN });
localize("zh_CN");

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

Vue.prototype.$apiAdmin = apiAdmin;
Vue.prototype.$qs = Qs;
Vue.prototype.$queryUrl = (url, params = {}) => {
  return url + "?" + Qs.stringify(params);
};

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
